module.exports = __webpack_public_path__ + "img/nav-honor-home-act.7de7009b.png";